module.exports = __webpack_public_path__ + "assets/img/light-tip.69e72216.svg";